import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";

const MobileSection = () => {
  const mobileBg = {
    backgroundImage: "url('/img/webpImg/mobileBg.webp')",
  };
  const items = [
    {
      image: "",
      text: "Price Drop Notifications",
    },
    {
      image: "",
      text: "Customized Deals groups",
    },
    {
      image: "",
      text: "Loot Deals",
    },
    {
      image: "",
      text: "Exclusive Deals",
    },
    {
      image: "",
      text: "Price Graph",
    },
  ];

  return (
    <div
      style={mobileBg}
      className="relative flex flex-col items-center h-full sm:hidden gap-9 "
    >
      <div className="flex flex-wrap items-center justify-center gap-3">
        {items.map((data, index) => (
          <div
            className="px-[10px] py-[7px] bg-white rounded-[68px] flex items-center gap-2"
            key={index}
          >
            <FontAwesomeIcon
              icon={faCheckDouble}
              style={{ color: "#ff6240" }}
            />
            <h3 className="text-[11px] font-medium leading-[116%]">
              {data.text}
            </h3>
          </div>
        ))}
      </div>

      <div className="bg-[#000] flex gap-2 items-center px-[14px] py-[6px] rounded-[5px] w-36">
        <img src="/img/webpImg/googleImage2.webp" alt="Google Download Image" />
      </div>

      <div className="w-[72vw]">
        <img src="/img/webpImg/mobileEnd.webp" alt="Image" className="w-full" />
      </div>
    </div>
  );
};

export default MobileSection;
